import { Flex, Popover, Tag, Typography } from 'antd';
import type { Citation } from '../types';

/**
 * Chips numbered by the server (`n` matches the `[n]` in the text); hover shows
 * the fact's label, value and source (spec §10), plus the tool and fact ID.
 * Every field is rendered as text, never as markup.
 */
const CitationChips = ({ citations }: { citations: Citation[] }) => (
  <Flex wrap gap={4}>
    {citations.map((citation) => (
      <Popover
        key={citation.n}
        title={citation.label}
        content={
          <div style={{ maxWidth: 320 }}>
            <div>
              <Typography.Text strong>Value: </Typography.Text>
              {citation.value === null ? '—' : String(citation.value)}
            </div>
            <div>
              <Typography.Text strong>Source: </Typography.Text>
              {citation.source || 'unknown'}
            </div>
            <Typography.Text
              type="secondary"
              style={{ fontSize: 11, wordBreak: 'break-all' }}
            >
              {`${citation.tool} · ${citation.factId}`}
            </Typography.Text>
          </div>
        }
      >
        <Tag color="blue" style={{ cursor: 'default' }}>
          {`[${citation.n}] ${citation.label}`}
        </Tag>
      </Popover>
    ))}
  </Flex>
);

export default CitationChips;
